import React from 'react';
import Screen from './Screen';
import {connect} from 'react-redux';
import shouldEventBeListedOnArchive from '../../misc/shouldEventBeListedOnArchive';
import TopBar from '../elements/TopBar/TopBar';
import EventListItem from '../elements/EventListItem';
import moment from 'moment';
import Scrollable from '../elements/Scrollable';

class Archive extends React.Component {
    render() {
        let {i18n} = this.props,
            header = <TopBar returnURL="..">{i18n['label.archived-events']}</TopBar>;
        console.log(this.props.events);
        return (
            <Screen header={header}>
                <Scrollable className="content">
                    {this.props.events.map(event => (
                        <EventListItem event={event} key={event.id} />
                    ))}
                </Scrollable>
            </Screen>
        );
    }
}

const ConnectedScreen = connect((state, props) => {
    let events = _(state.events)
        .values()
        .map('event')
        .filter({_isEvent: true})
        .filter({joined: true})
        .filter(shouldEventBeListedOnArchive)
        .sortBy(event => {
            return -1 * moment(event.end_utc).valueOf();
        })
        .value();
    return {
        i18n: state.i18n.translations,
        events: _(events)
            .filter(shouldEventBeListedOnArchive)
            .value(),
    };
})(Archive);

export default props => <ConnectedScreen {...props.match.params} />;
